<template>
  <div class="carousel" @click="setSlide(slide)">
    <transition name="carousel" mode="out-in">
      <div class="slide" :key="slide">
        <h2 v-html="lang.slides[slide].title" />
        <h3 v-html="lang.slides[slide].subtitle" />
        <div class="button-layout">
          <ButtonFlat v-scroll-to="'#video'" :label="lang.video" />
          <ButtonFlat v-scroll-to="'#info'" @click="changeSlide(slide + 1)" :label="lang.info" />
        </div>
      </div>
    </transition>
    <div class="carousel-bullets">
      <span
        v-for="index in lang.slides.length"
        :key="index"
        :class="{active: index == slide + 1}"
        @click="setSlide(index - 1)"
      />
    </div>
    <div class="carousel-button left" @click="setSlide(slide - 1)">&#171;</div>
    <div class="carousel-button right" @click="setSlide(slide + 1)">&#187;</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonFlat from "@/components/shared/button/ButtonFlat";

export default {
  name: "Carousel",
  components: { ButtonFlat },
  data: function() {
    return {
      slide: 0,
      speed: 10000,
      animation: false
    };
  },
  methods: {
    ...mapActions("infoSlides", ["changeSlide"]),
    startAnimation() {
      this.animation = setInterval(() => {
        this.slide = ++this.slide % this.lang.slides.length;
      }, this.speed);
    },
    setSlide(slide) {
      clearInterval(this.animation);
      this.slide = (slide + this.lang.slides.length) % this.lang.slides.length;
      this.startAnimation();
    }
  },
  created: function() {
    this.startAnimation();
  },
  computed: {
    ...mapGetters("languages", ["lang"])
  }
};
</script>

<style lang="scss" scoped>
span:empty::before {
  content: "\A0";
}

.carousel {
  position: absolute;
  z-index: $carousel-z-index;
  top: $carousel-top;
  width: $carousel-width;
  height: $carousel-height;
  text-align: center;
}

.slide {
  display: inline-block;
  width: 100%;
  max-width: $mobile-width;
  height: 100%;
  padding: $carousel-slide-padding;
}

h2 {
  @extend #{$carousel-slide-title-font-size};
  margin: $carousel-slide-title-margin;
  font-weight: $carousel-slide-title-font-weight;
}
h3 {
  @extend #{$carousel-slide-subtitle-font-size};
  margin-top: $carousel-slide-subtitle-margin-top;
  opacity: 0;
}
.button-layout {
  margin-top: $carousel-slide-button-layout-margin-top;
  opacity: 0;
  button:first-child {
    margin-right: $carousel-slide-button-margin;
  }
}

.carousel-bullets {
  position: absolute;
  bottom: 70px;
  width: 100%;
  text-align: center;
  span {
    display: inline-block;
    width: $carousel-bullet-size;
    height: $carousel-bullet-size;
    margin: 0 $carousel-bullet-margin;
    border: $carousel-bullet-color 1px solid;
    border-radius: $carousel-bullet-size/2;
    background-color: rgba(255, 255, 255, 0);
    cursor: pointer;
    transition-duration: $carousel-bullet-transition-duration;
    transition-timing-function: $carousel-bullet-transition-timing-function;
    transition-property: all;
    &.active {
      width: $carousel-bullet-size * 3;
      background-color: $carousel-bullet-color;
    }
  }
}

.carousel-button {
  position: absolute;
  width: $carousel-button-size;
  height: $carousel-button-size;
  line-height: $carousel-button-size;
  bottom: 40%;
  margin: $carousel-button-margin;
  font-size: $carousel-button-margin;
  vertical-align: middle;
  background-color: $carousel-button-background-color;
  border-radius: $carousel-button-size/2;
  opacity: $carousel-button-opacity;
  cursor: pointer;
  transition-property: opacity;
  transition-duration: $carousel-transition-duration;
  transition-timing-function: $carousel-transition-timing-function;
  &.right {
    right: 0;
  }
  &:hover {
    opacity: 1;
  }
  user-select: none;
  @media only screen and (max-width: $mobile-width) {
    display: none;
  }
}

.carousel-enter-active,
.carousel-leave-active {
  transition-property: all;
  transition-duration: $carousel-transition-duration;
  transition-timing-function: $carousel-transition-timing-function;
}

.carousel-enter {
  opacity: 0;
  transform: translateY($carousel-enter-translate-y);
}

.carousel-leave-to {
  opacity: 0;
  transform: translateY($carousel-leave-to-translate-y);
}

@keyframes slide-fade {
  from {
    margin-top: $carousel-slide-fade-margin-top;
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

h3,
.button-layout {
  animation-fill-mode: forwards;
  animation-name: slide-fade;
  animation-duration: $carousel-slide-fade-animation-duration;
  animation-timing-function: $carousel-slide-fade-animation-timing-function;
}

h3 {
  animation-delay: $carousel-slide-subtitle-animation-delay;
}

.button-layout {
  animation-delay: $carousel-slide-button-layout-animation-delay;
}
</style>
